const React = require("react");
const {Provider} = require("mobx-react");
const AuthService = require("services/Auth");
const CrudStoreFabricator = require("stores/abstract/CrudStoreFabricator");
const ModalContainerFabricator = require("components/modals/ModalContainer");
const Modal = require("components/modals/Modal");
const Icon = require("addons/Icon");
const {Button} = require("../triggers");
const env = require("services/env");
const router = require("services/router");
const Input = require("components/fields/simpletons/Input").inject();

class Session extends React.Component {

    constructor(props) {
        super(props);

        this.store = CrudStoreFabricator.create('backend_user', {}, false, 'session_store');

        this.state = {
            alive: AuthService.user && AuthService.user.has_active_session,
            digits: [],
            has_errors: false
        };

    }

    componentDidMount() {
        if (env.get('environment') !== 'local') {
            this.scheduleNextCheck();
        }

        this.toggleKeyboardListener(!this.state.alive);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.alive !== this.state.alive) {
            this.toggleKeyboardListener(!this.state.alive);
        }
    }

    componentWillUnmount() {
        this.toggleKeyboardListener(false);
    }

    toggleKeyboardListener(listen) {
        listen ?
            document.addEventListener('keydown', this.submitOnEnter) :
            document.removeEventListener('keydown', this.submitOnEnter);
    }

    submitOnEnter = (e) => {
        if (e.keyCode === 13) {
            this.handleConfirm();
        }
    }

    scheduleNextCheck(delay = 500) {
        setTimeout(() => {
            this.checkLastActivity().finally(() => {
                this.scheduleNextCheck(10000);
            });

        }, delay);
    }

    expireSession() {
        return this.store
            .customAction('expire_session', 0, {}, {}, false)
            .then(() => this.checkLastActivity())
    }

    checkLastActivity() {
        return this.store
            .customAction('check_last_activity', 0, {}, {}, false)
            .then(resp => {
                let currentStatus = resp.user && resp.user.has_active_session;
                if (currentStatus !== this.state.alive) {
                    this.setState({alive: currentStatus, has_errors: false});
                }
            })
    }

    digitClicked = (number) => {
        this.setState((state) => {
            if (state.digits.length < 4) {
                state.digits = [...state.digits, number];
            }
            return state;
        })
    }

    removeLastDigit = (number) => {
        this.setState((state) => {
            if (state.digits.length > 0) {
                state.digits.pop();
            }
            if (state.digits.length === 0) {
                state.has_errors = false;
            }
            return state;
        })
    }

    handleConfirm = () => {
        const options = {
            method: 'POST',
            url:    router.route('backend.session.confirm'),
            data:   {
                pin: this.state.digits.join(['']),
            },
        };

        this.store.custom(options)
            .then(resp => {
                if (resp.changed_user) {
                    return window.location = router.route('backend.home');
                }

                let currentStatus = resp.user && resp.user.has_active_session;
                if (currentStatus !== this.state.alive) {
                    if (currentStatus === true) {
                        this.modal.close(true);
                    }
                    this.setState({alive: currentStatus, digits: [], has_errors: resp.status});
                } else {
                    this.setState({digits: [], has_errors: !resp.status});
                }
            });
    }

    handlePasswordFieldChange = (val) => {

        let digits = val.split('');

        if (digits.length > 4) {
            digits.splice(4);
        }

        this.setState({digits: digits});

    }

    renderDigitsDisplay() {
        return this.state.digits.map((digit, index) => {
            return (
                <React.Fragment key={index} >
                    *
                </React.Fragment >
            );
        });
    }

    renderExpiredModalTitle() {
        return (
            <React.Fragment>
                <div className={'session-logout'}>
                    <Button className="btn arrow-left-link" type="none"
                            action={() => {window.location = router.url("backend/log-ud")}}>Log ud</Button>
                </div>
                <Icon name={'bloomit-colored'} />
            </React.Fragment>
        );
    }

    renderExpiredModal() {

        if (this.state.alive === true) {
            return null;
        }

        return (
            <React.Fragment >
                <div className={'session-expired-overlay'} ></div >
                <Modal ref={el => this.modal = el} title={this.renderExpiredModalTitle()}
                       className={['session-expired-modal'].join('')} defaultOpen={true} closeable={false} >
                    <div className={'digits-display'} >
                        <div className={(this.state.has_errors ? 'has-errors' : '')} >
                            <Input autoFocus={true} type={'password'} onChange={this.handlePasswordFieldChange.bind(this)} value={this.state.digits.join('')} />
                        </div >
                        <Button type={'arrow'} onClick={this.handleConfirm} />
                    </div >
                    <div className={'digits'} >
                        <div onClick={() => this.digitClicked(1)} >1</div >
                        <div onClick={() => this.digitClicked(2)} >2</div >
                        <div onClick={() => this.digitClicked(3)} >3</div >
                        <div onClick={() => this.digitClicked(4)} >4</div >
                        <div onClick={() => this.digitClicked(5)} >5</div >
                        <div onClick={() => this.digitClicked(6)} >6</div >
                        <div onClick={() => this.digitClicked(7)} >7</div >
                        <div onClick={() => this.digitClicked(8)} >8</div >
                        <div onClick={() => this.digitClicked(9)} >9</div >
                        <div onClick={() => this.digitClicked(0)} >0</div >
                        <div onClick={() => this.removeLastDigit()} >X</div >
                    </div >
                </Modal >
            </React.Fragment >
        );
    }

    render() {
        //{ModalContainerFabricator.renderContainer()}

        return (
            <Provider authSession={this} >
                <React.Fragment >
                    {this.props.children}
                    {this.renderExpiredModal()}
                </React.Fragment >
            </Provider>
        );
    }

}

module.exports = Session;
